import styled, { css } from 'styled-components';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { Container } from '@web/onboarding/Checklist/components/modalBase.style';

export const EmptyModalContainer = styled(Container)`
  min-height: 374px;
`;

export const disabledInputLookingLikeRegularCss = css`
  background-color: ${({ theme }) => theme.colors.white};
`;

export const TabButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

type TabButtonContentProps = {
  selected: boolean;
  selectionThemeColor: ThemeColorType;
};
export const TabButtonContent = styled.div<TabButtonContentProps>`
  display: flex;
  justify-items: center;
  align-items: center;
  padding: 20px;
  ${({ selected, selectionThemeColor, theme }) =>
    selected ? `border-bottom: 4px solid ${theme.colors[selectionThemeColor]}` : ''};
`;

export const TabArea = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
`;
